import React from "react";

type FilterButtonProps = {
  open: boolean;
  activeCount: number;
  onClick: () => void;
};

const FunnelIcon = () => (
  <svg
    viewBox="0 0 24 24"
    className="tw-h-[19px] tw-w-[19px]"
    style={{
      stroke: "#030562",
      fill: "none",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
    }}
    aria-hidden="true"
  >
    <path d="M3 4.5h18l-7 8.2v5.6l-4 2.2v-7.8z" />
  </svg>
);

const FilterButton = ({ open, activeCount, onClick }: FilterButtonProps) => (
  <button
    id="commend3-btn-filter"
    type="button"
    className="tw-inline-flex tw-h-[44px] tw-shrink-0 tw-items-center tw-gap-2 tw-rounded-md tw-px-3"
    style={{
      border: `1px solid ${open ? "#030562" : "transparent"}`,
      background: open ? "#EAF0FF" : "transparent",
      cursor: "pointer",
    }}
    onClick={(event) => {
      event.stopPropagation();
      onClick();
    }}
  >
    <FunnelIcon />
    <span className="tw-text-[15px] tw-text-[#030562]">Filter</span>
    {activeCount > 0 ? (
      <span className="tw-inline-flex tw-h-[19px] tw-min-w-[19px] tw-items-center tw-justify-center tw-rounded-full tw-bg-[#03B3FF] tw-px-1.5 tw-text-[11px] tw-font-bold tw-text-white">
        {activeCount}
      </span>
    ) : null}
  </button>
);

export default FilterButton;
